import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoutes = () => {
   const token = localStorage.getItem("TOKEN");
   return token ? <Outlet /> : <Navigate to={`${process.env.PUBLIC_URL}/login`} />;
}
export default PrivateRoutes;